const ISSUE_NOTIFICATION_CONFIGURATION_API_PATH =
  '/issues-tracking/v1/issues/config/notifications';
const ISSUE_USERS_API_PATH = '/issues-tracking/v1/issues/users';

export { ISSUE_NOTIFICATION_CONFIGURATION_API_PATH, ISSUE_USERS_API_PATH };
